import {TrackingPageContext} from './tracking-page';

export type TrackingPromotion = {
  readonly id: number | string; // depends on the promotion

  readonly name: string;

  /**
   * Place where the promotion is displayed
   */
  readonly creative: TrackingPromotionCreative;
  readonly creativeName?: string;
  readonly creativeSlot?: string;

  readonly destination: TrackingPromotionDestination;

  readonly locationId?: string;

  readonly highlightId?: string;
};

export type TrackingPromotionDestination =
  | TrackingPromotionNoDestination
  | TrackingPromotionInternalDestination
  | TrackingPromotionExternalDestination
  | TrackingPromotionVideoDestination
  | TrackingPromotionFromEndpoint
  | TrackingPromotionLiveShopping;

export interface TrackingPromotionFromEndpoint {
  readonly type: 'from-endpoint';
  readonly destination: string;
  readonly url: string;
}

export interface TrackingPromotionNoDestination {
  readonly type: 'no-destination';
}

export interface TrackingPromotionInternalDestination {
  readonly type: 'internal';
  readonly page: TrackingPageContext;
}

export interface TrackingPromotionExternalDestination {
  readonly type: 'external';
  readonly url: string;
}

export interface TrackingPromotionLiveShopping {
  readonly type: 'liveshopping';
  readonly url: string;
}

export interface TrackingPromotionVideoDestination {
  readonly type: 'video';
}

export type ContentBlockLocation =
  | 'header'
  | 'headline'
  | 'text'
  | 'imageTextModule'
  | 'threeColumnsModule'
  | 'imageTile'
  | 'videoTile'
  | 'cta'
  | 'doubleTile'
  | 'assetSlider';

export enum TrackingPromotionCreative {
  AppsalePhoneNumberSend = 'desktop_appsale_phone-number-send',
  AppsaleAppStoreBadge = 'desktop_appsale_app-store-badge',
  AppsalePlayStoreBadge = 'desktop_appsale_play-store-badge',
  AppsaleCampaignBanner = 'appsale_campaign_banner',
  AppsaleToast = 'appsale_toast',
  AppsalePopUp = 'appsale_pop_up',
  Banner = 'banner',
  BasBrowseBrandTeaser = 'bas_browse_brand_teaser',
  BasBrowseSecondaryTeaser = 'bas_browse_secondary_teaser',
  BasAdpPriceBoxIntegration = 'bas_adp_price_box_integration',
  BasAdpTabIntegration = 'bas_adp_tab_integration',
  BasAdpDetailIntegration = 'bas_adp_detail_integration',
  BasAdpBanner = 'bas_adp_banner',
  BasAddToBasketBanner = 'bas_add_to_basket_banner',
  BasAddToBasketFlyOut = 'bas_add_to_basket_flyOut',
  BasBasketBanner = 'bas_basket_banner',
  BasNavigationBanner = 'bas_navigation_banner',
  BasWishlistBanner = 'bas_wishlist_banner',
  BasStoryTeaser = 'bas_story_teaser',
  BasOutfitTeaser = 'bas_outfit_teaser',
  BasOspBanner = 'bas_osp_banner',
  BasOspSubscriptionTile = 'bas_osp_subscription_tile',
  BasTrackNTraceBanner = 'bas_track_n_trace_banner',
  BasCategoryTeaser = 'bas_category_teaser',
  BasCategoryHeader = 'bas_category_header',
  BasBrandOverviewSlider = 'bas_brand_slider',
  BasPremiumLandingpageHeader = 'bas_premium_landingpage_header',
  BasPremiumLandingpageSingleTile = 'bas_premium_landingpage_single_tile',
  BasPremiumLandingpageDoubleTile = 'bas_premium_landingpage_double_tile',
  BasFlyoutTeaser = 'bas_flyout_teaser',
  BasLogoIntegration = 'bas_logo_integration',
  BasBrowseTopBanner = 'bas_browse_topbanner',
  BasSearch = 'bas_search',
  Highlight = 'highlight',
  Newscard = 'newscard',
  NewscardVideo = 'newscard_video',
  IdolReco = 'idol_reco',
  StoryReco = 'story_reco',
  Story = 'story',
  OutfitReco = 'outfit_reco',
  BrandReco = 'brand_reco',
  Brand = 'brand',
  CategoryReco = 'category_reco',
  Editorial = 'editorial',
  EditorialVideo = 'editorial_video',
  EditorialImageNoDestination = 'editorial_image_no_destination',
  EditorialVideoNoDestination = 'editorial_video_no_destination',
  Button = 'button',
  Link = 'link',
  StaticImage = 'static_image',
  SecondHand = 'second_hand',
  Sovendus = 'sovendus_osp_placement',
  LiveShopping = 'liveshoppingPlayer',
  LiveShoppingFab = 'liveshoppingFAB',
  Teaser = 'teaser',
  Monitoring = 'monitoring',
  CustomPage = 'custom_page',
  NotificationCenterCards = 'NotificationCenterCards',
  APIPromotion = 'APIPromotion',
  outfitSliderADP = 'outfit_adp_reco',
  outfitSliderCategory = 'outfit_category_reco',
  OutfitSliderBrand = 'outfit',
}
